module.exports = __webpack_public_path__ + "img/202412_06.f3d4caba.jpg";